import cx from 'classnames';
import isNumber from 'lodash/isNumber';
import { memo } from 'react';

import { toRoman } from '~/helpers/formatting';

import styles from './ClanLeagueSign.scss';

import { getImagePath } from './clanLeagueSign.utils';

import type { ILadderSeason, LadderSeasonLeagueDivision, LadderSeasonLeagueIcons } from '~/store/slices/settingsSlice';

type ImageSizeState = {
  leagueIcon: keyof LadderSeasonLeagueIcons;
  ribbon: keyof LadderSeasonLeagueIcons;
  ribbonWide: keyof LadderSeasonLeagueIcons;
  divisionIcon: keyof LadderSeasonLeagueDivision['icons'];
  progressStub: keyof LadderSeasonLeagueIcons;
  stars: string;
  viewportSizeType: string;
};

interface ClanLeagueSignDivisionNumberProps {
  clanDivision?: number;
  clanLeague?: number;
  divisionIndex: number | null;
  img: ImageSizeState;
  isFullSize: boolean;
  seasonInfo: ILadderSeason | null;
}

const ClanLeagueSignDivisionNumber = ({
  clanDivision,
  clanLeague,
  divisionIndex,
  img,
  isFullSize,
  seasonInfo,
}: ClanLeagueSignDivisionNumberProps) => {
  const league = isNumber(clanLeague) ? seasonInfo?.leagues?.[clanLeague] : undefined;
  if (!league) {
    return <div className={styles.clanDivisionNumber}>{toRoman(clanDivision ?? 0)}</div>;
  }

  const divisionData =
    divisionIndex != null && league.divisions?.[divisionIndex] ? league.divisions[divisionIndex] : null;
  const divisionIcon = divisionData?.icons;

  const divisionNumberStyle = divisionIcon
    ? {
        backgroundImage: `url("${getImagePath(divisionIcon[img.divisionIcon])}")`,
      }
    : undefined;

  return divisionIcon ? (
    <div
      style={divisionNumberStyle}
      className={cx(styles.clanDivisionNumberIcon, {
        [styles.fullSize]: isFullSize,
      })}
    />
  ) : (
    <div className={styles.clanDivisionNumber}>{toRoman(clanDivision ?? 0)}</div>
  );
};

export default memo(ClanLeagueSignDivisionNumber);
